import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AlertNotification, ErrorBoundary, Theme, SizerWrapper, themeOptions } from '@commonsku/styles';
import Header from './Header';
import MainSection from './MainSection';
import { GlobalStyle } from './DashboardApp';

class FinancePaymentsApp extends Component {
  render() {
    const { forwardPayments = {} } = this.props;
    const { login_url: loginUrl, error } = forwardPayments;

    return (
      <Theme theme={themeOptions}>
        <GlobalStyle />
        <ErrorBoundary>
          <div className="resku" style={{ background: 'rgb(237, 242, 245)' }}>
            <Header />
          </div>
          <div>
            <div className="resku">
              <MainSection style={{ background: 'rgb(237, 242, 245)' }} />
            </div>
            <div className="main-content csku-styles" style={{ marginTop: '0rem' }}>
                {(!loginUrl || error) && (
                    <AlertNotification alertType="error">{error || 'Unable to load the payments portal. Please try again later.'}</AlertNotification>
                )}
                {loginUrl && (
                    <iframe
                    title="Payments Dashboard"
                    src={loginUrl}
                    style={{ width: '100%', height: 'calc(100dvh - 88px)', border: 'none' }}
                    />
                )}
            </div>
          </div>
        </ErrorBoundary>
      </Theme>
    );
  }
}

const mapStateToProps = (state) => ({
  forwardPayments: state.forwardPayments,
});

export default connect(mapStateToProps)(FinancePaymentsApp);
